import Conditions from '../constants/conditions';
import UserPermissions from '../constants/userPermissions';
import WorkspacesComponents from '../constants/workspacesComponents';
import { PartialRecord, PermissionRules } from '../usePermissions';

type workspacesComponentRegistry = {
  [name in WorkspacesComponents]: PermissionRules;
};

const WorkspacesComponentRegistry: workspacesComponentRegistry = {
  OptimizationPreferences: {
    [UserPermissions.CREATE_OPTIMIZATION]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      if (conditions.workspaceDeleted) return false;
      return true;
    },
  },
  RouteTemplates: {
    [UserPermissions.VIEW_ROUTE_TEMPLATES]: true,
    [UserPermissions.EDIT_ROUTE_TEMPLATES]: true,
    [UserPermissions.DELETE_ROUTE_TEMPLATES]: true,
    [UserPermissions.CREATE_ROUTE_TEMPLATES]: true,
  },
  WorkspaceSettings: {
    [UserPermissions.VIEW_WORKSPACE_SETTINGS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      if (conditions.workspaceDeleted) return false;
      return true;
    },
    [UserPermissions.EDIT_WORKSPACE_SETTINGS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      if (conditions.workspaceDeleted) return false;
      return true;
    },
    [UserPermissions.VIEW_CUSTOMER_NOTIFICATION_SETTINGS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      if (conditions.workspaceDeleted) return false;
      return true;
    },
    [UserPermissions.EDIT_CUSTOMER_NOTIFICATION_SETTINGS]: (conditions: PartialRecord<Conditions, boolean>) => {
      if (conditions.isSynced) return false;
      if (conditions.workspaceDeleted) return false;
      return true;
    },
  },
};

export default WorkspacesComponentRegistry;
